module.exports = __webpack_public_path__ + "static/assets/af6582cb7347b51e2090d3ed60f6ebd4.svg";